import { useState, useEffect, useRef } from "react";
import axios from "axios";
import SideMenu from "../../features/sideMenu/SideMenu";
import Activo from "../../assets/img/svg/providers/providerActivo.svg";
import Inactivo from "../../assets/img/svg/providers/providerExpirado.svg";
import Ajustes from "../../assets/img/svg/users/opciones.svg";
import DescargarG from "../../assets/img/svg/users/descargarGreen.svg";
import Documentacion from "../../assets/img/svg/users/documentacion.svg";
import Eliminar from "../../assets/img/svg/users/eliminar.svg";
import Instaladores from "../../assets/img/svg/providers/instaladores.svg";
import Editar from "../../assets/img/svg/users/editar.svg";
import EnProceso from "../../assets/img/svg/providers/providerEnProceso.svg";
import Anadir from "../../assets/img/svg/anadir.svg";
import Visible from "../../assets/img/svg/providers/visible.svg";
import Ocultar from "../../assets/img/svg/providers/ocultar.svg";
import IconActivo from "../../assets/img/svg/providers/vigente.svg";
import IconInactivo from "../../assets/img/svg/providers/expirado.svg";
import IconenProceso from "../../assets/img/svg/providers/enProceso.svg";
import IconInhabilitar from "../../assets/img/svg/providers/Inhabilitar.svg";
import { useNavigate } from "react-router-dom";
import Card from "../../features/cards/CardsGraph";
import CustomSelect from "../../ui/select/Select";
import useConfirmDialog from "../../features/modal/ConfirmDialog";
import "react-circular-progressbar/dist/styles.css";
import { exportarProveedoresAExcel } from "../../utils/exportHelpers";
import {
  formatEmpresa,
  formatName,
  formatCobertura,
  formatEspecialidades,
  highlightText,
} from "../../utils/functionsFormat";
import {
  headCellCenterAlign,
  bodyCellCenterAlign,
  headCellLeftAlign,
} from "../../utils/columnStyles";
import CustomButton from "../../ui/button/Button";
import {
  confirmarDescargarExcel,
  deleteProvider,
  updateProvider,
} from "../functions/Functions";
import { deshabilitarEmpresa, habilitarEmpresa } from "../functions/Providers";
import { itemsProviders } from "../../constants/providers";
import TablaMRT from "../../features/table/RTable";
import {
  customNumberFilter,
  customStringFilter,
  customStatusFilter,
  customSpecialtyFilter,
} from "../../features/table/filterFunctions";
import "./ProvidersPage.responsive.css";
import { ClickAwayListener, Popper, Box } from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import TrackerProvidersStepper from "../../features/stepper/TrackerProviderStepper";
import { MRT_Localization_ES } from "material-react-table/locales/es";
import {
  getTrackerProveedoresEvents,
  getTrackerProveedores,
} from "../functions/Notifications";
import TrackerStepperProviders from "../../features/stepper/TrackerStepperProviders";
import { splitPhones, buildWaHref } from "../../utils/numberContact";
import LoaderDialog from "../../ui/loader/Loader";

const OpcionesFiltro = (graph = false) => {
  const opcionesFiltro = [
    { value: "Todos", name: "Todos" },
    { value: "Activo", name: "Activo" },
    { value: "proceso de integración", name: "En proceso" },
    { value: "Inactivo", name: "Inactivo" },
  ];

  return opcionesFiltro;
};

const ProvidersPage = ({ API_URL, user }) => {
  const [data, setData] = useState([]);
  const [dataOriginal, setDataOriginal] = useState([]);

  const [activeSelectIndex, setActiveSelectIndex] = useState(null);
  const [openMenuIndex, setOpenMenuIndex] = useState(null);

  const [filtroSeleccionado, setFiltroSeleccionado] = useState("Todos");
  const [estadoContratoFiltro, setEstadoContratoFiltro] = useState("Todos");
  const [opcionesFiltroModificadas, setOpcionesFiltroModificadas] = useState(
    OpcionesFiltro()
  );
  const [filteredBase, setFilteredBase] = useState([]);
  const [showActions, setShowActions] = useState(false);
  const pdfRef = useRef();
  const showDialog = useConfirmDialog();

  const [tableInstance, setTableInstance] = useState(null);
  const rowIconRefEstado = useRef({});
  const [etapaSeleccionada, setEtapaSeleccionada] = useState(null);
  const [selectedProvider, setSelectedProvider] = useState(null);
  const [events, setEvents] = useState([]);

  const [width, setWidth] = useState(window.innerWidth);

  const [showLoader, setShowLoader] = useState(false);

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [window.innerWidth]);

  useEffect(() => {
    const fetchEvents = async () => {
      if (selectedProvider) {
        const events = await getTrackerProveedoresEvents(
          API_URL,
          selectedProvider.id
        );
        if (events.length > 0) {
          setEvents(events);
        } else {
          setEvents([
            {
              id: 0,
              id_trabajo: null,
              id_empresa: selectedProvider.id,
              etapa: 1,
              estatus: "pendiente",
              id_usuario: user.id,
              created_at: new Date().toISOString(),
              updated_at: new Date().toISOString(),
            },
          ]);
        }
      } else {
        setEvents([
          {
            id: 0,
            id_trabajo: null,
            id_empresa: 0,
            etapa: 1,
            estatus: "pendiente",
            id_usuario: user.id,
            created_at: new Date().toISOString(),
            updated_at: new Date().toISOString(),
          },
        ]);
      }
    };
    fetchEvents();
  }, [selectedProvider]);

  const handleEtapaFilter = (etapa) => {
    if (tableInstance) tableInstance.resetExpanded();
    setSelectedProvider(null);
    if (etapa === etapaSeleccionada) {
      setEtapaSeleccionada(null);
      setData(dataOriginal);
      return;
    }
    setEtapaSeleccionada(etapa);
    const filtered = dataOriginal.filter((empresa) => empresa.etapa === etapa);
    setData(filtered);
  };

  const ordenarPorEstadoVigencia = (rowA, rowB, columnId) => {
    const orden = {
      VIGENTE: 0,
      PROXIMO_A_EXPIRAR: 1,
      EXPIRADO: 2,
      NO_EXISTENTE: 3,
    };
    return (
      (orden[rowA.getValue(columnId)] ?? 99) -
      (orden[rowB.getValue(columnId)] ?? 99)
    );
  };

  const normalizeVigencia = (v) => {
    if (!v) return "NO_EXISTENTE";
    const s = String(v).toUpperCase();
    if (s.includes("VALID") || s.includes("VIGENTE")) return "VIGENTE";
    if (s.includes("EXPIRED") || s.includes("EXPIRADO")) return "EXPIRADO";
    if (s.includes("PROX") || s.includes("VENCER") || s.includes("EXPIRAR"))
      return "PROXIMO_A_EXPIRAR";
    return "NO_EXISTENTE";
  };

  const getDocStatus = (empresa, tipo) => {
    const T = String(tipo || "").toUpperCase();
    const docs = empresa?.documentosEmpresa || [];

    // match case-insensitive por name o lenguaje
    const doc = docs.find((d) => {
      const n = String(d?.tipoDocumento?.name || "").toUpperCase();
      const l = String(d?.tipoDocumento?.lenguaje || "").toUpperCase();
      return n === T || l === T;
    });

    // ✅ Fallback: CONTRATO puede venir fuera de documentosEmpresa
    if (!doc && T === "CONTRATO") {
      const fv = empresa?.contrato?.fechaVencimiento;
      if (!fv) return { estado: "NO_EXISTENTE", fecha: null, link: null };

      const dias = Math.floor(
        (new Date(fv) - new Date()) / (1000 * 60 * 60 * 24)
      );
      const estado =
        dias < 0 ? "EXPIRADO" : dias <= 60 ? "PROXIMO_A_EXPIRAR" : "VIGENTE";
      return { estado, fecha: fv, link: null };
    }

    if (!doc) return { estado: "NO_EXISTENTE", fecha: null, link: null };

    // 1) Intentar con el enum de vigencia que manda el backend
    let estado =
      normalizeVigencia(doc?.vigencia?.name) ||
      normalizeVigencia(doc?.vigencia?.lenguaje);

    // 2) Si no viene el enum, calcular por fecha
    if ((!estado || estado === "NO_EXISTENTE") && doc?.fechaVencimiento) {
      const dias = Math.floor(
        (new Date(doc.fechaVencimiento) - new Date()) / (1000 * 60 * 60 * 24)
      );
      estado =
        dias < 0 ? "EXPIRADO" : dias <= 60 ? "PROXIMO_A_EXPIRAR" : "VIGENTE";
    }

    return {
      estado: estado || "NO_EXISTENTE",
      fecha: doc?.fechaVencimiento || null,
      link: doc?.link || null,
    };
  };

  const Verificador = (status, fechaVencimiento, graph = false) => {
    const color =
      status === "VIGENTE"
        ? "green"
        : status === "EXPIRADO"
        ? "red"
        : status === "PROXIMO_A_EXPIRAR"
        ? "orange"
        : "gray";

    const fmt = (f) => {
      if (!f) return "Sin definir";
      const d = new Date(f);
      if (isNaN(d.getTime())) return "Sin definir";
      const dd = String(d.getDate()).padStart(2, "0");
      const mm = String(d.getMonth() + 1).padStart(2, "0");
      const yyyy = d.getFullYear();
      return `${dd}-${mm}-${yyyy}`;
    };

    return graph ? (
      <div
        style={{
          width: 16,
          height: 16,
          borderRadius: "50%",
          backgroundColor: color,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#fff",
          fontSize: 10,
        }}
      >
        {fmt(fechaVencimiento)}
      </div>
    ) : (
      <div
        style={{
          width: 70,
          height: 18,
          border: `2px solid ${color}`,
          borderRadius: 14,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: 10,
          color: "#000",
        }}
      >
        <span style={{ paddingTop: 1 }}>{fmt(fechaVencimiento)}</span>
      </div>
    );
  };

  const HoverTooltip = ({ title, children, placement = "top" }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    return (
      <span
        onMouseEnter={(e) => setAnchorEl(e.currentTarget)}
        onMouseLeave={() => setAnchorEl(null)}
        style={{ display: "inline-flex" }}
      >
        {children}
        <Popper
          open={open}
          anchorEl={anchorEl}
          placement={placement}
          style={{ zIndex: 2000 }}
        >
          <ClickAwayListener onClickAway={() => setAnchorEl(null)}>
            <div
              style={{
                background: "#000",
                borderRadius: 6,
                padding: "6px 8px",
                boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                color: "#fff",
                fontSize: 15,
                whiteSpace: "nowrap",
                margin: 8,
                fontFamily: "Nunito",
              }}
            >
              {title}
            </div>
          </ClickAwayListener>
        </Popper>
      </span>
    );
  };

  const eliminarProveedores = (id, nombreEmpresa) => {
    confirmDialog({
      html: `¿Estás seguro de que deseas eliminar el proveedor <b>${nombreEmpresa}</b>?`,
      icon: "warning",
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
      mostrarCancelar: true,
      iconClass: "!",
      onConfirm: async () => {
        try {
          await deleteProvider(API_URL, id);
          confirmDialog({
            html: "El proveedor fue eliminado con éxito.",
            icon: "success",
            confirmButtonText: "Aceptar",
            mostrarCancelar: false,
          });
        } catch (error) {
          confirmDialog({
            html: `Ocurrió un error al eliminar la empresa.<br>${
              error.response?.data?.message || error.message
            }`,
            icon: "error",
            confirmButtonText: "Aceptar",
            mostrarCancelar: false,
          });
        }
      },
    });
  };

  const exportarExcelCompleto = () => {
    showDialog({
      title: "Confirmar contraseña",
      html: `
        <input type="password" id="input-password" class="swal2-input" placeholder="Contraseña de operación" />
      `,
      confirmButtonText: "Confirmar",
      icon: "question",
      onConfirm: () => {
        const contrasena = document.getElementById("input-password").value;
        if (!contrasena) {
          showDialog({
            html: "Por favor ingresa tu contraseña.",
            icon: "warning",
            confirmButtonText: "Aceptar",
            mostrarCancelar: false,
          });
          return;
        }

        confirmarDescargarExcel(
          API_URL,
          contrasena,
          showDialog,
          exportarExcelCompleto
        );
      },
    });
  };

  const navigate = useNavigate();
  const contratoEmpresa = async (id) => {
    navigate(`/proveedores/documentos/${id}`);
  };

  const statusProvider = (empresa, estatus, nombre, estatusEmpresa) => {
    const nombreFormateado = formatEmpresa(nombre);

    let iconPath;
    let message;
    switch (estatus) {
      case "activo":
        iconPath = Activo;
        message = `<p class="text-dialog">
       ${nombreFormateado} será establecida como:<br> 
       <strong>
         <img src="${IconActivo}" alt="vigente" style="width:12px; height:12px; vertical-align:middle; margin-right:5px;" />
         Activo
       </strong><br> 
       Podrás cambiar su estatus en cualquier momento.
     </p>`;
        break;
      case "inactivo":
        iconPath = Inactivo;
        message = `<p class="text-dialog">${nombreFormateado} será establecida como:<br> 
             <strong>
              <img src="${IconInactivo}" alt="vigente" style="width:12px; height:12px; vertical-align:middle; margin-right:5px;" />
             Inactivo</strong><br> Podrás cambiar su estatus en cualquier momento. <br> <br> También puedes inhabilitar el proveedor.</p>`;
        break;
      case "proceso de integración":
        iconPath = EnProceso;
        message = `<p class="text-dialog">${nombreFormateado} será establecida como:<br> <strong>
               <img src="${IconenProceso}" alt="vigente" style="width:12px; height:12px; vertical-align:middle; margin-right:5px;" />
             En proceso</strong><br> Podrás cambiar su estatus en cualquier momento.</p>`;
        break;
    }
    confirmDialog({
      html: message,
      icon: "warning",
      iconHtml: "!",
      confirmButtonText: "Aceptar",
      cancelButtonText: "Cancelar",
      onConfirm: async () => {
        try {
          const partes = (empresa.nombre || "").trim().split(" ");
          const nombreSeparado = partes[0] || "";
          const apellidosSeparados = partes.slice(1).join(" ") || "";
          const payload = {
            ...empresa,
            estatus: estatus,
            estatusEmpresa: estatusEmpresa,
            habilitada: empresa.habilitada === false ? false : true,
            nombre: nombreSeparado,
            apellidos: apellidosSeparados || " ",
          };

          await updateProvider(API_URL, payload);
          if (estatus !== "inactivo" && empresa.habilitada === false) {
            await habilitarEmpresa(API_URL, empresa.id);
          }
          setData((prevData) =>
            prevData.map((item) =>
              item.id === empresa.id
                ? {
                    ...item,
                    estatusEmpresa: {
                      ...item.estatusEmpresa,
                      nombre: estatus,
                    },
                    habilitada:
                      estatus !== "inactivo" ? true : empresa.habilitada,
                  }
                : item
            )
          );
          confirmDialog({
            html: "El estatus se actualizó correctamente.",
            icon: "success",
            confirmButtonText: "Aceptar",
            mostrarCancelar: false,
          });
        } catch (error) {
          console.error("Error al modificar estatus empresa:", error);
        }
      },
      showDenyButton: estatus === "inactivo" ? true : false,
      denyButtonText: "Inhabilitar",
      denyButtonColor: "#851f1f",
      reverseButtons: true,
      onDeny: async () => {
        confirmDialog({
          html: `
            <p class="text-dialog">
              ¿Seguro que desea inhabilitar esta empresa?<br />
              <strong>
                <img
                  src="${IconInhabilitar}"
                  alt="inactivo"
                  style="width:12px; height:12px; vertical-align:middle; margin-right:5px;"
                />
                Inhabilitar
              </strong>
              <br />
              Sus trabajos asignados serán concluidos y los usuarios asociados a la misma serán eliminados.
            </p>
          `,
          icon: "warning",
          confirmButtonText: "Aceptar",
          mostrarCancelar: true,
          reverseButtons: true,
          onConfirm: async () => {
            try {
              await deshabilitarEmpresa(API_URL, empresa.id);
              setData((prevData) =>
                prevData.map((item) =>
                  item.id === empresa.id
                    ? {
                        ...item,
                        estatusEmpresa: {
                          ...item.estatusEmpresa,
                          nombre: estatus,
                        },
                        habilitada: false,
                      }
                    : item
                )
              );
              confirmDialog({
                html: "El estatus se actualizó correctamente.",
                icon: "success",
                confirmButtonText: "Aceptar",
                mostrarCancelar: false,
              });
            } catch (error) {
              console.error("Error al modificar estatus empresa:", error);
            }
          },
        });
      },
    });
  };

  const calculateProgress = (status, baseArray = data) => {
    const total = baseArray.filter(
      (e) =>
        e.estatusEmpresa?.nombre?.toLowerCase() === "activo" &&
        (!etapaSeleccionada || e.etapa === etapaSeleccionada)
    ).length;
    if (total === 0) return 0;

    const count = countByRange(status, baseArray);
    return Math.round((count / total) * 100);
  };

  const calculateStatusProgress = (status, baseArray = data) => {
    const total = baseArray.filter(
      (item) => !etapaSeleccionada || item.etapa === etapaSeleccionada
    ).length;
    if (total === 0) return 0;

    const count = countByStatus(status, baseArray);
    return Math.round((count / total) * 100);
  };

  const fetchData = async (buscarInhabilitados = false) => {
    setShowLoader(true);
    const [trackerData, response] = await Promise.all([
      getTrackerProveedores(API_URL),
      axios.post(
        `${API_URL}/api/empresas-por-criterios`,
        {
          razonSocial: null,
          rfc: null,
          cobertura: null,
          coberturaForanea: null,
          numbreContacto: null,
          especialidad: null,
          numGafete: null,
          estatusEmpresa: null,
          buscarInhabilitadas: buscarInhabilitados,
        },
        { withCredentials: true }
      ),
    ]);

    const newData = response.data.map((prov) => {
      const trackerForProv = trackerData.find(
        (tracker) => tracker.id_empresa === prov.id
      );
      if (trackerForProv) {
        return {
          ...prov,
          etapa: trackerForProv.etapa,
          tracker: trackerForProv,
        };
      } else {
        return {
          ...prov,
          etapa: 1,
          tracker: {
            id: 0,
            id_usuario: user.id,
            id_empresa: prov.id,
            etapa: 1,
            fecha_actualizacion: new Date().toISOString(),
            estatus: "pendiente",
            tipo: "proyecto",
          },
        };
      }
    });

    setShowLoader(false);

    setData(newData);
    setDataOriginal(newData);
    setFilteredBase(newData);
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const normalizaEstatusEmpresa = (empresa) => {
      const raw = empresa?.estatusEmpresa?.nombre?.toLowerCase() || "inactivo";
      return ["periodo de prueba", "no deseado"].includes(raw)
        ? "inactivo"
        : raw;
    };

    // 1) Armar cards según opción seleccionada
    if (filtroSeleccionado === "Todos") {
      // Estatus
      setOpcionesFiltroModificadas(OpcionesFiltro());
    } else if (filtroSeleccionado === "Activo") {
      // Instalaciones
      setOpcionesFiltroModificadas([
        { value: "Rango1", name: "Menos de 40%" },
        { value: "Rango2", name: "Entre 40% y 80%" },
        { value: "Rango3", name: "Más del 80%" },
        { value: "SinCapacidad", name: "Sin capacidad" },
      ]);
    } else if (
      ["REPSE", "SUA", "SIPARE", "CONTRATO"].includes(filtroSeleccionado)
    ) {
      // Documentos
      setOpcionesFiltroModificadas(DocOpcionesFiltro());
    }

    // 2) Filtrado de tabla según opción + card seleccionada
    if (filtroSeleccionado === "Todos") {
      // Filtra por estatus (cards: Activo / En proceso / Inactivo)
      const filteredData =
        estadoContratoFiltro === "Todos"
          ? filteredBase
          : filteredBase.filter(
              (e) =>
                normalizaEstatusEmpresa(e) ===
                estadoContratoFiltro.toLowerCase()
            );
      setData(
        filteredData.filter(
          (empresa) => !etapaSeleccionada || empresa.etapa === etapaSeleccionada
        )
      );
      return;
    }

    if (filtroSeleccionado === "Activo") {
      // Filtra por rangos de instalaciones
      if (
        ["Rango1", "Rango2", "Rango3", "SinCapacidad"].includes(
          estadoContratoFiltro
        )
      ) {
        const filteredData = filteredBase.filter((empresa) => {
          const capacidadTotal = empresa.capacidadInstalaciones || 0;
          const instalacionesActivas = empresa.instalacionesActivas || 0;
          const estadoEmpresa = normalizaEstatusEmpresa(empresa);
          if (estadoEmpresa !== "activo") return false;

          if (estadoContratoFiltro === "SinCapacidad") {
            return capacidadTotal === 0;
          }

          if (!capacidadTotal) return false;
          const porcentaje = (instalacionesActivas / capacidadTotal) * 100;
          if (estadoContratoFiltro === "Rango1") return porcentaje < 40;
          if (estadoContratoFiltro === "Rango2")
            return porcentaje >= 40 && porcentaje <= 80;
          if (estadoContratoFiltro === "Rango3") return porcentaje > 80;
          return false;
        });
        setData(
          filteredData.filter(
            (empresa) =>
              !etapaSeleccionada || empresa.etapa === etapaSeleccionada
          )
        );
      } else {
        setData(
          filteredBase.filter(
            (empresa) =>
              !etapaSeleccionada || empresa.etapa === etapaSeleccionada
          )
        );
      }
      return;
    }

    if (["REPSE", "SUA", "SIPARE", "CONTRATO"].includes(filtroSeleccionado)) {
      const filteredData =
        estadoContratoFiltro === "Todos"
          ? filteredBase
          : filteredBase.filter(
              (e) =>
                getDocStatus(e, filtroSeleccionado).estado ===
                estadoContratoFiltro
            );
      setData(
        filteredData.filter(
          (empresa) => !etapaSeleccionada || empresa.etapa === etapaSeleccionada
        )
      );
      return;
    }

    // Fallback
    setData(
      filteredBase.filter(
        (empresa) => !etapaSeleccionada || empresa.etapa === etapaSeleccionada
      )
    );
  }, [
    filtroSeleccionado,
    estadoContratoFiltro,
    filteredBase,
    etapaSeleccionada,
  ]);

  const [mostrarInhabilitados, setMostrarInhabilitados] = useState(false);

  const handleClick = () => {
    const nuevoEstado = !mostrarInhabilitados;
    setMostrarInhabilitados(nuevoEstado);
    fetchData(nuevoEstado); // llama a fetchData con true o false
  };

  const confirmDialog = useConfirmDialog();

  const editarEmpresa = async (id) => {
    navigate(`/proveedores/editar/${id}`);
  };

  const verInstaladores = async (empresaId) => {
    navigate(`/proveedores/instaladores/${empresaId}`);
  };

  const rowIconRef = useRef([]); // Ref único para cada fila

  const toggleSelect = (index) => {
    setActiveSelectIndex((prevIndex) => (prevIndex === index ? null : index));
  };
  const toggleMenuOptions = (index) => {
    setOpenMenuIndex((prev) => (prev === index ? null : index));
  };
  const handleCardClick = (status) => {
    setEstadoContratoFiltro(status);

    const base = filteredBase;

    if (
      ["Todos", "Activo", "Inactivo", "proceso de integración"].includes(status)
    ) {
      const filteredData = base.filter((empresa) => {
        const rawStatus =
          empresa.estatusEmpresa?.nombre?.toLowerCase() || "inactivo";
        const estadoEmpresa = ["periodo de prueba", "no deseado"].includes(
          rawStatus
        )
          ? "inactivo"
          : rawStatus;

        return estadoEmpresa === status.toLowerCase() || status === "Todos";
      });

      setData(
        filteredData.filter(
          (empresa) => !etapaSeleccionada || empresa.etapa === etapaSeleccionada
        )
      );
    } else if (["Rango1", "Rango2", "Rango3"].includes(status)) {
      const filteredData = base.filter((empresa) => {
        const capacidadTotal = empresa.capacidadInstalaciones || 0;
        const instalacionesActivas = empresa.instalacionesActivas || 0;
        const estadoEmpresa =
          empresa.estatusEmpresa?.nombre?.toLowerCase() || "inactivo";

        if (capacidadTotal === 0 || estadoEmpresa !== "activo") return false;

        const porcentaje = (instalacionesActivas / capacidadTotal) * 100;

        if (status === "Rango1") return porcentaje < 40;
        if (status === "Rango2") return porcentaje >= 40 && porcentaje <= 80;
        if (status === "Rango3") return porcentaje > 80;

        return false;
      });

      setData(
        filteredData.filter(
          (empresa) => !etapaSeleccionada || empresa.etapa === etapaSeleccionada
        )
      );
    } else if (status === "SinCapacidad") {
      const filteredData = base.filter((empresa) => {
        const rawStatus =
          empresa.estatusEmpresa?.nombre?.toLowerCase() || "inactivo";
        const estadoEmpresa = ["periodo de prueba", "no deseado"].includes(
          rawStatus
        )
          ? "inactivo"
          : rawStatus;

        return (
          estadoEmpresa === "activo" &&
          (!empresa.capacidadInstalaciones ||
            empresa.capacidadInstalaciones === 0)
        );
      });

      setData(
        filteredData.filter(
          (empresa) => !etapaSeleccionada || empresa.etapa === etapaSeleccionada
        )
      );
    }
  };

  const handleFilterChange = (selectedOption) => {
    setFiltroSeleccionado(selectedOption);
    if (selectedOption === "Activo") {
      setEstadoContratoFiltro("Rango1");
    } else {
      setEstadoContratoFiltro("Todos"); // reset card
    }
  };

  const countByStatus = (status, baseArray = data) => {
    if (status === "Todos")
      return baseArray.filter(
        (item) => !etapaSeleccionada || item.etapa === etapaSeleccionada
      ).length;

    return baseArray.filter((empresa) => {
      const rawStatus =
        empresa?.estatusEmpresa?.nombre?.toLowerCase() || "inactivo";
      const estadoEmpresa = ["periodo de prueba", "no deseado"].includes(
        rawStatus
      )
        ? "inactivo"
        : rawStatus;

      return (
        estadoEmpresa === status?.toLowerCase() &&
        (!etapaSeleccionada || empresa.etapa === etapaSeleccionada)
      );
    }).length;
  };

  const countByRange = (status, baseArray = data) => {
    if (status === "SinCapacidad") {
      return baseArray.filter((empresa) => {
        const rawStatus =
          empresa.estatusEmpresa?.nombre?.toLowerCase() || "inactivo";
        const estadoEmpresa = ["periodo de prueba", "no deseado"].includes(
          rawStatus
        )
          ? "inactivo"
          : rawStatus;

        return (
          estadoEmpresa === "activo" &&
          (!empresa.capacidadInstalaciones ||
            empresa.capacidadInstalaciones === 0) &&
          (!etapaSeleccionada || empresa.etapa === etapaSeleccionada)
        );
      }).length;
    }

    return baseArray
      .filter((empresa) => {
        const capacidadTotal = empresa.capacidadInstalaciones || 0;
        const instalacionesActivas = empresa.instalacionesActivas || 0;

        const rawStatus =
          empresa.estatusEmpresa?.nombre?.toLowerCase() || "inactivo";
        const estadoEmpresa = ["periodo de prueba", "no deseado"].includes(
          rawStatus
        )
          ? "inactivo"
          : rawStatus;

        if (capacidadTotal === 0 || estadoEmpresa !== "activo") return false;

        const porcentaje = (instalacionesActivas / capacidadTotal) * 100;

        if (status === "Rango1") return porcentaje < 40;
        if (status === "Rango2") return porcentaje >= 40 && porcentaje <= 80;
        if (status === "Rango3") return porcentaje > 80;

        return false;
      })
      .filter((item) => !etapaSeleccionada || item.etapa === etapaSeleccionada)
      .length;
  };

  const DocOpcionesFiltro = () => [
    { value: "Todos", name: "Todos" },
    { value: "VIGENTE", name: "Vigente" },
    { value: "PROXIMO_A_EXPIRAR", name: "Próximo a vencer" },
    { value: "EXPIRADO", name: "Vencido" },
    { value: "NO_EXISTENTE", name: "No existente" },
  ];

  const countByDocStatus = (docType, status, baseArray = filteredBase) => {
    if (status === "Todos")
      return baseArray.filter(
        (item) => !etapaSeleccionada || item.etapa === etapaSeleccionada
      ).length;
    return baseArray.filter(
      (empresa) =>
        getDocStatus(empresa, docType).estado === status &&
        (!etapaSeleccionada || empresa.etapa === etapaSeleccionada)
    ).length;
  };

  const calculateDocProgress = (docType, status, baseArray = filteredBase) => {
    const total =
      baseArray.filter(
        (item) => !etapaSeleccionada || item.etapa === etapaSeleccionada
      ).length || 0;
    if (!total) return 0;
    const count = countByDocStatus(docType, status, baseArray);
    return Math.round((count / total) * 100);
  };

  const DOC_COLORS = {
    VIGENTE: "#62C776",
    EXPIRADO: "#EC3E49",
    PROXIMO_A_EXPIRAR: "#FEBC61",
    NO_EXISTENTE: "#878787",
  };

  const columns = [
    {
      accessorKey: "razonSocial",
      header: "Empresa",
      size: 125,
      filterFn: customStringFilter,
      meta: { filterVariant: "texto" },
      muiTableHeadCellProps: {
        sx: headCellLeftAlign,
        "& .MuiTableSortLabel-root": { display: "none", pointerEvents: "none" },
      },
      Cell: ({ cell, table }) => {
        const valor = cell.getValue();
        const texto = typeof valor === "string" ? valor : "";
        const search = table.getState().globalFilter;
        const formateado = formatEmpresa(texto);
        return <>{highlightText(formateado, search)}</>;
      },
    },
    {
      accessorKey: "nombre",
      header: "Nombre",
      size: 145,
      filterFn: customStringFilter,
      meta: { filterVariant: "texto" },
      muiTableHeadCellProps: {
        sx: headCellLeftAlign,
      },
      Cell: ({ cell, table }) => {
        const valor = cell.getValue();
        const texto = typeof valor === "string" ? valor : "";
        const search = table.getState().globalFilter;
        const formateado = formatName(texto);
        return <>{highlightText(formateado, search)}</>;
      },
    },
    {
      accessorKey: "telefono",
      header: "Teléfono",
      size: 100,
      filterFn: customNumberFilter,
      meta: { filterVariant: "numberico" },
      muiTableHeadCellProps: {
        title: "Teléfono",
        sx: headCellLeftAlign,
      },
      Cell: ({ cell }) => {
        const raw = String(cell.getValue() ?? "");
        const numbers = splitPhones(raw);

        return (
          <div
            onClick={(e) => e.stopPropagation()}
            style={{ display: "flex", gap: 8, flexWrap: "wrap" }}
          >
            {numbers.map((n, i) => (
              <a
                key={i}
                href={buildWaHref(n)}
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: "underline" }}
                onClick={(e) => e.stopPropagation()}
                title={`Enviar WhatsApp a ${n}`}
              >
                {n}
              </a>
            ))}
          </div>
        );
      },
    },
    {
      accessorKey: "cobertura",
      header: "Cobertura sin viáticos",
      Header: () => (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            minWidth: 0,
            width: "100%",
          }}
        >
          <span
            style={{
              minWidth: 0,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              width: "100%",
            }}
          >
            Cobertura
          </span>
          <span
            style={{
              minWidth: 0,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              width: "100%",
            }}
          >
            sin viáticos
          </span>
        </div>
      ),
      size: 125,
      filterFn: customStringFilter,
      meta: { filterVariant: "texto" },
      //filterFn: "includesString",
      //columnFilterModeOptions: ["fuzzy", "contains", "startsWith", "endsWith"],
      muiTableHeadCellProps: {
        title: "Cobertura sin viáticos",
        sx: headCellLeftAlign,
        minWidth: 0,
        overflow: "hidden",
        "& .Mui-TableHeadCell-Content, & .Mui-TableHeadCell-Content-Labels": {
          minWidth: 0,
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        },
      },
      Cell: ({ cell, table }) => {
        const value = cell.getValue();
        const search = table.getState().globalFilter;
        const texto = formatCobertura(value);
        return <span>{highlightText(texto, search)}</span>;
      },
    },
    {
      accessorKey: "capacidadInstalaciones",
      header: "Capacidad total",
      Header: () => (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            minWidth: 0,
          }}
        >
          <Box
            sx={{
              minWidth: 0,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              width: "100%",
            }}
          >
            Capacidad
          </Box>
          <Box component="span">total</Box>
        </Box>
      ),
      size: 70,

      filterFn: customNumberFilter,
      meta: { filterVariant: "numerico" },
      muiTableHeadCellProps: {
        title: "Capacidad total",
        sx: headCellCenterAlign,
        minWidth: 0, // 👈 permite encoger el <th>
        overflow: "hidden", // 👈 evita que el contenido empuje
        "& .Mui-TableHeadCell-Content": { minWidth: 0 },
        "& .Mui-TableHeadCell-Content-Labels": {
          minWidth: 0,
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        },
      },
      muiTableBodyCellProps: {
        sx: bodyCellCenterAlign,
        minWidth: 0,
      },
      Cell: ({ cell, table }) => {
        const value = cell.getValue();
        const search = table.getState().globalFilter;
        const texto = value ? String(value) : "0";
        return (
          <span style={{ whiteSpace: "nowrap" }}>
            {highlightText(texto, search)}
          </span>
        );
      },
    },
    {
      accessorKey: "instalacionesActivas",
      header: "Instalaciones activas",
      Header: () => (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            minWidth: 0,
          }}
        >
          <span
            style={{
              minWidth: 0,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              width: "100%",
            }}
          >
            Instalaciones
          </span>
          <span>activas</span>
        </div>
      ),
      size: 80,
      filterFn: customNumberFilter,
      meta: { filterVariant: "numerico" },
      muiTableHeadCellProps: {
        title: "Instalaciones activas",
        sx: headCellCenterAlign,
      },
      muiTableBodyCellProps: {
        sx: bodyCellCenterAlign,
      },
    },
    {
      accessorKey: "especialidades.nombre",
      header: "Especialidad",
      size: 170,
      fontSize: 12,
      filterFn: customSpecialtyFilter,
      meta: { filterVariant: "specialty" },
      muiTableHeadCellProps: {
        sx: headCellLeftAlign,
      },

      Cell: ({ row, table }) => {
        const especialidades = row.original.especialidadesSelec;
        const search = table.getState().globalFilter;
        const texto = formatEspecialidades(especialidades);
        return <>{highlightText(texto, search)}</>;
      },
    },
    {
      accessorFn: (row) => getDocStatus(row, "REPSE").estado,
      id: "empresa-repse",
      header: "REPSE",
      size: 87,
      sortingFn: ordenarPorEstadoVigencia,
      filterFn: customStatusFilter,
      meta: { filterVariant: "estado" },
      muiTableHeadCellProps: { sx: headCellCenterAlign },
      muiTableBodyCellProps: { sx: bodyCellCenterAlign },
      Cell: ({ row }) => {
        const { estado, fecha } = getDocStatus(row.original, "REPSE");
        const title =
          estado === "VIGENTE"
            ? "Vigente"
            : estado === "EXPIRADO"
            ? "Vencido"
            : estado === "PROXIMO_A_EXPIRAR"
            ? "Próximo a vencer"
            : "No existente";

        const pill = (
          <div className="status-circle-page">{Verificador(estado, fecha)}</div>
        );
        return (
          <HoverTooltip title={title} placement="top">
            {pill}
          </HoverTooltip>
        );
      },
    },
    {
      accessorFn: (row) => getDocStatus(row, "SUA").estado,
      id: "empresa-sua",
      header: "SUA",
      size: 87,
      sortingFn: ordenarPorEstadoVigencia,
      filterFn: customStatusFilter,
      meta: { filterVariant: "estado" },
      muiTableHeadCellProps: { sx: headCellCenterAlign },
      muiTableBodyCellProps: { sx: bodyCellCenterAlign },
      Cell: ({ row }) => {
        const { estado, fecha } = getDocStatus(row.original, "SUA");
        const title =
          estado === "VIGENTE"
            ? "Vigente"
            : estado === "EXPIRADO"
            ? "Vencido"
            : estado === "PROXIMO_A_EXPIRAR"
            ? "Próximo a vencer"
            : "No existente";

        const pill = (
          <div className="status-circle-page">{Verificador(estado, fecha)}</div>
        );
        return (
          <HoverTooltip title={title} placement="top">
            {pill}
          </HoverTooltip>
        );
      },
    },
    {
      accessorFn: (row) => getDocStatus(row, "SIPARE").estado,
      id: "empresa-sipare",
      header: "SIPARE",
      size: 87,
      sortingFn: ordenarPorEstadoVigencia,
      filterFn: customStatusFilter,
      meta: { filterVariant: "estado" },
      muiTableHeadCellProps: { sx: headCellCenterAlign },
      muiTableBodyCellProps: { sx: bodyCellCenterAlign },
      Cell: ({ row }) => {
        const { estado, fecha } = getDocStatus(row.original, "SIPARE");
        const title =
          estado === "VIGENTE"
            ? "Vigente"
            : estado === "EXPIRADO"
            ? "Vencido"
            : estado === "PROXIMO_A_EXPIRAR"
            ? "Próximo a vencer"
            : "No existente";

        const pill = (
          <div className="status-circle-page">{Verificador(estado, fecha)}</div>
        );
        return (
          <HoverTooltip title={title} placement="top">
            {pill}
          </HoverTooltip>
        );
      },
    },
    {
      accessorFn: (row) => getDocStatus(row, "CONTRATO").estado,
      id: "empresa-contrato",
      header: "Contrato",
      size: 110,
      sortingFn: ordenarPorEstadoVigencia,
      filterFn: customStatusFilter,
      meta: { filterVariant: "estado" },
      muiTableHeadCellProps: { sx: headCellCenterAlign },
      muiTableBodyCellProps: { sx: bodyCellCenterAlign },
      Cell: ({ row }) => {
        const { estado, fecha } = getDocStatus(row.original, "CONTRATO");
        const title =
          estado === "VIGENTE"
            ? "Vigente"
            : estado === "EXPIRADO"
            ? "Vencido"
            : estado === "PROXIMO_A_EXPIRAR"
            ? "Próximo a vencer"
            : "No existente";
        return (
          <HoverTooltip title={title} placement="top">
            <div className="status-circle-page">
              {Verificador(estado, fecha)}
            </div>
          </HoverTooltip>
        );
      },
    },
    {
      accessorKey: "estatusEmpresa.nombre",
      header: "Estatus",
      size: 85,
      filterFn: customStatusFilter,
      meta: { filterVariant: "estatus" },
      //enableColumnFilterModes: false,
      //filterSelectOptions: [
      //{ label: "Activo", value: "Activo" },
      //{ label: "Inactivo", value: "Inactivo" },
      //{ label: "En proceso", value: "proceso de integración" },
      //],
      //filterVariant: "select",
      muiTableHeadCellProps: {
        sx: headCellCenterAlign,
      },
      Cell: ({ cell, row }) => {
        const value = cell.getValue();
        const estado =
          typeof value === "string" ? value.toLowerCase().trim() : "";

        const icon =
          estado === "activo"
            ? Activo
            : estado === "inactivo" || estado === "no deseado"
            ? Inactivo
            : EnProceso;

        return (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              position: "relative",
              width: "100%",
            }}
          >
            <img
              ref={(el) => (rowIconRefEstado.current[row.id] = el)}
              src={icon}
              alt={estado}
              style={{ width: "20px", height: "20px", cursor: "pointer" }}
              onClick={() => toggleSelect(row.id)}
            />

            <Popper
              open={activeSelectIndex === row.id}
              anchorEl={rowIconRefEstado.current[row.id]}
              placement="bottom"
              style={{ zIndex: 1302 }}
            >
              <ClickAwayListener onClickAway={() => setActiveSelectIndex(null)}>
                <div
                  style={{
                    backgroundColor: "#fff",
                    border: "1px solid #ccc",
                    borderRadius: "6px",
                    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
                    minWidth: "150px",
                    padding: "4px 0",
                  }}
                >
                  {(() => {
                    //  Normalización solo para el menú
                    const normalizeForMenu = (s = "") => {
                      const v = String(s).toLowerCase().trim();
                      if (v === "no deseado") return "inactivo";
                      if (
                        v === "en proceso" ||
                        v === "en proceso de integración" ||
                        v === "proceso de integración" ||
                        v === "periodo de prueba"
                      ) {
                        return "proceso de integración";
                      }
                      return v;
                    };

                    const estadoActualMenu = normalizeForMenu(estado);

                    const OPCIONES = [
                      {
                        estado: { id: 1, nombre: "activo" },
                        icon: Activo,
                        label: "Activo",
                      },
                      {
                        estado: { id: 10, nombre: "inactivo" },
                        icon: Inactivo,
                        label: "Inactivo",
                      },
                      {
                        estado: { id: 12, nombre: "proceso de integración" },
                        icon: EnProceso,
                        label: "En proceso",
                      },
                    ];

                    const opcionesVisibles = OPCIONES.filter(
                      (o) =>
                        normalizeForMenu(o.estado.nombre) !== estadoActualMenu
                    );

                    return opcionesVisibles.map(({ estado, icon, label }) => (
                      <div
                        key={estado.id}
                        style={{
                          padding: "8px 12px",
                          cursor: "pointer",
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                          whiteSpace: "nowrap",
                          fontSize: "14px",
                        }}
                        onClick={() => {
                          statusProvider(
                            row.original,
                            estado.nombre,
                            row.original.razonSocial,
                            estado
                          );
                          setActiveSelectIndex(null);
                        }}
                      >
                        <img
                          src={icon}
                          alt={label}
                          style={{ width: "20px", height: "20px" }}
                        />
                        {label}
                      </div>
                    ));
                  })()}
                </div>
              </ClickAwayListener>
            </Popper>
          </div>
        );
      },
    },
    {
      header: " ",
      size: 60,
      muiTableHeadCellProps: {
        sx: headCellCenterAlign,
      },
      muiTableBodyCellProps: {
        sx: bodyCellCenterAlign,
      },

      Cell: ({ row }) => (
        <div
          style={{ position: "relative", zIndex: 1000, overflow: "visible" }}
        >
          <button
            ref={(el) => (rowIconRef.current[row.index] = el)}
            onClick={() => toggleMenuOptions(row.index)}
            className="action-icon"
          >
            <img
              src={Ajustes}
              alt="Ajustes"
              style={{ width: "20px", height: "20px" }}
            />
          </button>

          <Popper
            open={openMenuIndex === row.index}
            anchorEl={rowIconRef.current[row.index]}
            placement="bottom-start"
            style={{ zIndex: 1302 }}
          >
            <ClickAwayListener onClickAway={() => setOpenMenuIndex(null)}>
              <div
                className="dropdown-menu-user"
                style={{
                  position: "static",
                  top: "30px", // Aproximadamente debajo del ícono
                  right: "0",
                  backgroundColor: "#fff",
                  border: "1px solid #ccc",
                  borderRadius: "8px",
                  boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                  padding: "10px",
                  minWidth: "200px",
                  zIndex: 1302,
                }}
              >
                <p onClick={() => contratoEmpresa(data[row.index].id)}>
                  <img src={Documentacion} alt="" /> Documentación
                </p>
                <p onClick={() => editarEmpresa(data[row.index].id)}>
                  <img src={Editar} alt="" /> Editar proveedor
                </p>
                <p
                  onClick={() =>
                    eliminarProveedores(
                      data[row.index].id,
                      data[row.index].razonSocial
                    )
                  }
                >
                  <img src={Eliminar} alt="" /> Eliminar proveedor
                </p>
                {row?.original?.habilitada === true && (
                  <p onClick={() => verInstaladores(data[row.index].id)}>
                    <img src={Instaladores} alt="" /> Ver instaladores
                  </p>
                )}
              </div>
            </ClickAwayListener>
          </Popper>
        </div>
      ),
    },
  ];

  const options = {
    localization: { ...MRT_Localization_ES, expand: "Tracker" },
    enableColumnFilters: false,
    enablePagination: true,
    enableSorting: true,
    enableExpandAll: false,
    fontSize: 10,
    padding: 10,
    initialState: {
      pagination: {
        pageSize: 5, // Cambia el número de filas por página a 10
        pageIndex: 0,
      },
    },
    muiTableBodyRowProps: ({ row }) => {
      const inhabilitada = row.original.habilitada === false;
      return {
        sx: {
          backgroundColor: inhabilitada ? "#F2F2F2" : "inherit",
          color: inhabilitada ? "#6E6E6E" : "inherit",
          fontStyle: inhabilitada ? "italic" : "normal",
        },
      };
    },

    muiExpandButtonProps: ({ row, table }) => ({
      children: row.getIsExpanded() ? (
        <ArrowDropUpIcon color="success" />
      ) : (
        <ArrowDropDownIcon color="success" />
      ),
      onClick: () => {
        if (!row.getIsExpanded()) {
          setSelectedProvider(row.original);
        } else {
          setSelectedProvider(null);
        }
        table.setExpanded({ [row.id]: !row.getIsExpanded() });
      },
    }),
    renderDetailPanel: ({ row }) => (
      <div
        style={{
          backgroundColor: "#f9f9f9",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          width: "86vw",
          padding: "20px",
          gap: "20px",
        }}
      >
        <h2 style={{ margin: 0 }}>
          Tracking:{" "}
          {row.original.razonSocial
            ? formatEmpresa(row.original.razonSocial)
            : ""}
        </h2>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            width: "600px",
            backgroundColor: "#FFFFFF",
            padding: "10px 30px",
            borderRadius: "12px",
            boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
            alignItems: "center",
          }}
        >
          <h2 style={{ margin: 0 }}>Etapa</h2>
          <h2 style={{ margin: 0 }}>Detalles</h2>
          <h2 style={{ margin: 0 }}>Acciones</h2>
        </div>
        <TrackerProvidersStepper
          API_URL={API_URL}
          events={events}
          user={user}
          id_empresa={row.original.id}
          setEvents={setEvents}
          nombre={row.original.razonSocial}
          empresa_email={row.original.email}
        />
      </div>
    ),
  };

  const opcionesFiltro = [
    { value: "Todos", name: "Estatus" },
    { value: "Activo", name: "Instalaciones" },
    { value: "REPSE", name: "REPSE" },
    { value: "SUA", name: "SUA" },
    { value: "SIPARE", name: "SIPARE" },
    { value: "CONTRATO", name: "Contrato" },
  ];

  const exportBtnRef = useRef(null);

  return (
    <div className="pp-container" style={{ display: "flex", width: "100%" }}>
      <LoaderDialog open={showLoader} />

      <div className="pp-sidebar" style={{ width: "12rem" }}>
        <SideMenu items={itemsProviders} />
      </div>

      <div
        className="pp-main"
        style={{ flex: 1, padding: "10px", width: "80%" }}
      >
        {/* Filtro superior */}
        <div className="pp-filters">
          <CustomSelect
            options={opcionesFiltro}
            value={filtroSeleccionado}
            onChange={(e) => handleFilterChange(e.target.value)}
            fontWeight={"700"}
            color={"#223D51"}
            heightOption={"160px"}
            topOption={"calc(110%)"}
            width={"240px"}
            optionsWidth={"240px"}
            fontSize={"12px"}
            placeholder={"Seleccione filtro"}
          />
        </div>

        {/* Tarjetas / métricas */}
        <div
          className="pp-cardsRow"
          style={{ display: "flex", gap: "20px", marginBottom: "10px" }}
        >
          {opcionesFiltroModificadas.map((opcion) => {
            const isDoc = ["REPSE", "SUA", "SIPARE", "CONTRATO"].includes(
              filtroSeleccionado
            );
            //const isDoc = DOCUMENT_FILTERS.has(filtroSeleccionado);
            const docColor = isDoc
              ? DOC_COLORS[opcion.value] ?? "#CCCCCC"
              : undefined;
            const isInst = filtroSeleccionado === "Activo";

            const count = isInst
              ? countByRange(opcion.value, filteredBase)
              : isDoc
              ? countByDocStatus(filtroSeleccionado, opcion.value, filteredBase)
              : countByStatus(opcion.value, filteredBase);

            const progress =
              opcion.value === "Todos"
                ? undefined
                : isInst
                ? calculateProgress(opcion.value, filteredBase)
                : isDoc
                ? calculateDocProgress(
                    filtroSeleccionado,
                    opcion.value,
                    filteredBase
                  )
                : calculateStatusProgress(opcion.value, filteredBase);

            return (
              <Card
                key={opcion.value}
                status={opcion.name}
                count={count}
                onClick={() => handleCardClick(opcion.value)}
                progress={progress}
                {...(docColor && { color: docColor })}
                style={{
                  boxShadow:
                    estadoContratoFiltro === opcion.value
                      ? "0 5px 15px rgba(0, 0, 0, 0.35)"
                      : "none",
                }}
              />
            );
          })}
        </div>

        <TrackerStepperProviders
          width={width}
          selectedProvider={selectedProvider}
          etapaSeleccionada={etapaSeleccionada}
          handleEtapaFilter={handleEtapaFilter}
        />

        {/* Título + acciones */}
        <div
          className="pp-actions"
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            marginBottom: "20px",
          }}
        >
          <h2 style={{ margin: 0 }}>Proveedores</h2>
          <CustomButton
            background="#62C776"
            width="126px"
            height="31px"
            fontSize="14px"
            color="#FFFFFF"
            text="Añadir nuevo"
            fontWeight={700}
            border={0}
            icon
            src={Anadir}
            iconW="12px"
            iconM="5px"
            onClick={() => navigate("/proveedores/nuevo")}
          />

          <span ref={exportBtnRef} style={{ display: "inline-block" }}>
            <CustomButton
              background="#223D51"
              width="94px"
              height="31px"
              fontSize="12px"
              color="#FFFFFF"
              text="Exportar"
              fontWeight={700}
              border="0.5px solid #C3C3C3"
              icon
              src={DescargarG}
              iconW="12px"
              iconM="5px"
              onClick={() => setShowActions((s) => !s)}
            />
          </span>

          <Popper
            open={showActions}
            anchorEl={exportBtnRef.current}
            placement="bottom-start" // justo donde inicia el botón
            style={{ zIndex: 2000 }}
          >
            <ClickAwayListener onClickAway={() => setShowActions(false)}>
              <div
                className="box-action"
                style={{
                  background: "#fff",
                  border: "1px solid #C3C3C3",
                  borderRadius: "8px",
                  boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                  padding: "8px",
                  minWidth: 200,
                }}
              >
                <p
                  onClick={() => {
                    if (tableInstance)
                      exportarProveedoresAExcel(
                        tableInstance.getFilteredRowModel().rows
                      );
                  }}
                  className="box-button-action"
                >
                  Formato Excel
                </p>
                <p
                  onClick={() => {
                    setShowActions(false);
                    const filteredRows =
                      tableInstance?.getFilteredRowModel().rows || [];
                    const filteredData = filteredRows.map((r) => r.original);
                    pdfRef.current?.generarPDF(filteredData);
                  }}
                  className="box-button-action"
                >
                  Formato PDF
                </p>
                <p
                  onClick={exportarExcelCompleto}
                  className="box-button-action"
                >
                  Excel Completo
                </p>
              </div>
            </ClickAwayListener>
          </Popper>

          <CustomButton
            background={mostrarInhabilitados ? "#FFFFFF" : "#223D51"}
            width="170px"
            height="31px"
            fontSize="12px"
            color={mostrarInhabilitados ? "#223D51" : "#FFFFFF"}
            text={
              mostrarInhabilitados
                ? "Ocultar Inhabilitados"
                : "Mostrar Inhabilitados"
            }
            fontWeight={700}
            border="0.5px solid #C3C3C3"
            icon
            src={mostrarInhabilitados ? Ocultar : Visible}
            iconW="12px"
            iconM="5px"
            onClick={handleClick}
          />
        </div>

        <div className="pp-tableWrap">
          <TablaMRT
            columns={columns}
            data={data}
            options={options}
            onTableReady={(table) => setTableInstance(table)}
          />
        </div>
      </div>
    </div>
  );
};

export default ProvidersPage;
